import { useCallback, useState } from 'react';
import { AssetSortMode } from '../utils/analysisGrouping';

const STORAGE_KEY = 'assetAnalysisSortMode';
const DEFAULT_MODE: AssetSortMode = 'episodeCount';

function readStoredMode(): AssetSortMode {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'episodeCount' || saved === 'appearance') return saved;
  } catch {
    // storage 不可用（隐私模式/被禁用）时回落默认值
  }
  return DEFAULT_MODE;
}

/**
 * 资产分析组间排序方式，localStorage 全局记忆（跨项目共享）。
 * 读写失败均静默回落：读失败用默认值，写失败仅会话内生效。
 */
export function useAssetSortMode(): [AssetSortMode, (mode: AssetSortMode) => void] {
  const [mode, setMode] = useState<AssetSortMode>(readStoredMode);

  const update = useCallback((next: AssetSortMode) => {
    setMode(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // 写失败降级为会话内生效
    }
  }, []);

  return [mode, update];
}
